/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import './Map.css';
import mapOptions from './MapOptions.js';
import { GoogleMap, useLoadScript, Marker } from '@react-google-maps/api';
import iconMarker from '../../icons/marker.svg';
import iconMarkerBlack from '../../icons/marker-black.svg';
import { getPharmacies } from './MapUtils.js';
import isEmpty from 'lodash/isEmpty';
import isEqual from 'lodash/isEqual';
import Text from '../Text/Text';
import SearchBar from '../SearchBar/SearchBar';
import PharmaList from '../PharmaList/PharmaList';

const DEFAULT_ZOOM = 5;
const DEFAULT_POSITION = {
  lat: 46.856614,
  lng: 2.3522219000000177,
};

const Map = () => {
  const [pharmacies, setPharmacies] = useState([]);
  const [selectedPharmacy, setSelectedPharmacy] = useState(null);
  const [query, setQuery] = useState('');
  const [position, setPosition] = useState(DEFAULT_POSITION);
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: process.env.RAZZLE_GOOGLEMAP_KEY,
  });

  useEffect(() => {
    getPharmacies(setPharmacies, query);
  }, [query]);

  useEffect(() => {
    if (!isEmpty(selectedPharmacy)) {
      setPosition(selectedPharmacy._geoloc);
    }
  }, [selectedPharmacy]);

  return (
    <div className="Map">
      {loadError ? (
        <Text classname="Map__infos" greenLight={true}>
          Une erreur est apparue
        </Text>
      ) : isLoaded ? (
        <GoogleMap
          mapContainerClassName="Map__map"
          zoom={DEFAULT_ZOOM}
          center={position}
          options={mapOptions}
        >
          {pharmacies.map((pharmacy) => (
            <Marker
              position={pharmacy._geoloc}
              key={pharmacy.name}
              icon={
                !isEmpty(selectedPharmacy) &&
                isEqual(selectedPharmacy.objectID, pharmacy.objectID)
                  ? iconMarker
                  : iconMarkerBlack
              }
              onClick={() => {
                setSelectedPharmacy(pharmacy);
              }}
            />
          ))}
        </GoogleMap>
      ) : (
        <Text classname="Map__infos" greenLight={true}>
          Chargement...
        </Text>
      )}
      <div className="Map__controls">
        <SearchBar
          classname="Map__search"
          label="Trouvez votre pharmacie"
          placeholder="Rechercher une pharmacie"
          value={query}
          onChange={setQuery}
        />
        <PharmaList
          pharmacies={pharmacies}
          className="Map__list"
          selectedPharmacy={selectedPharmacy}
          setSelectedPharmacy={setSelectedPharmacy}
        />
      </div>
      <div className="Map__footer"></div>
    </div>
  );
};

export default Map;
